import './view.scss';




import { processAccordians } from './accordian/view';
import { processButtons } from './buttons/view';
import { processForms } from './form/view';
import { processGalleries } from './gallery/view';
import { processHomes } from './homes/view';
import { processImages } from './image/view';
import { processSlides } from './slides/view';
import { processTabs } from './tabs/view';
import { popup } from './popup/view';

window.processBlocks = (base = document) => {
    processAccordians(base);
    processButtons(base);
    processForms(base);
    processGalleries(base);
    processHomes(base);
    processImages(base);
    processSlides(base);
    processTabs(base);
    processConditions(base);
}
window.headerHeight = 0;
window.stickyNavHeight = 0;
window.wpAdminHeight = 0;
window.addEventListener('DOMContentLoaded',()=>{
    processBlocks();
    document.querySelectorAll('#header-blocks > div').forEach(el=>{headerHeight=Math.max(headerHeight,el.offsetHeight)});
    const wpadmin = document.querySelector('#wpadminbar');
    if(wpadmin) wpAdminHeight = wpadmin.offsetHeight;
    const stickynav = document.querySelector('#stickynav');
    if(stickynav) {
        stickyNavHeight = stickynav.offsetHeight;
        stickynav.style.height = stickyNavHeight + 'px';
        stickynav.style.setProperty('--pinnedTop', (headerHeight+wpAdminHeight)+'px');
        ScrollTrigger.create({
            trigger: stickynav,
            start: 'top '+(headerHeight+wpAdminHeight),
            end: 999999,
            toggleClass: 'pinned'
        });
    }
    document.querySelectorAll('iframe').forEach(el=>{
        el.href = el.src;
        el.src = 'about:blank';
        ScrollTrigger.create({
            trigger: el,
            onToggle: self => { if(self.isActive&&(el.src!=el.href)) { el.src = el.href; self.kill(); } }
        });
    });
    document.querySelectorAll('a[href^="#"]').forEach(el=>{
        el.onclick = (e) => {
            e.preventDefault();
            const anchor = document.querySelector(el.getAttribute('href'));
            let top = 0;
            if(anchor) top = anchor.offsetTop - (headerHeight + stickyNavHeight);
            window.scrollTo({top,behavior:'smooth'});
            const stickynav = el.closest('.wp-block-navigation__responsive-container');
            if(stickynav) {
                document.documentElement.classList.remove('has-modal-open');
                stickynav.classList.remove('is-menu-open', 'has-modal-open');
            }
        } 
    });
    document.querySelectorAll('[data-inline]').forEach(el=>{
        renderImage({url:el.dataset.inline,alt:''}).then(img=>{
            el.innerHTML = img;
        })
    });
});

export function processConditions(base = document) {
    base.querySelectorAll('[class*="hide-on-condition-"]').forEach(el=>{
        for(let c of el.classList.values()) {
            if(c.startsWith('hide-on-condition-')) {
                const condition = c.split('hide-on-condition-')[1];
                const found = document.querySelector('[data-condition="'+condition+'"]');
                if(found) {
                    //el.remove();
                    el.style.display = 'none';
                } else {
                    el.classList.remove(c);
                }
            }
        }
    });
    base.querySelectorAll('[class*="select-on-cta-"]').forEach(el=>{
        if(!window.ctaRef) return;
        for(let c of el.classList.values()) {
            if(c.startsWith('select-on-cta-')) {
                const condition = c.split('select-on-cta-')[1];
                if(window.ctaRef.includes(condition)) {
                    const tabs = el.closest('.wp-block-smarttouch-tabs');
                    const labels = tabs.querySelector('.tab-labels');
                    const panels = tabs.querySelector('.tab-panels');
                    panels.querySelectorAll('.wp-block-smarttouch-tab').forEach((p,i)=>{
                        p.classList.add('is-hidden');
                        labels.children[i].classList.remove('is-active');
                        if(p==el) labels.children[i].classList.add('is-active');
                    });
                    el.classList.remove('is-hidden');
                }
            }
        }
    });
    base.querySelectorAll('[class*="hide-if-no-"]').forEach(el=>{
        if(!window.attsList) return;
        for(let c of el.classList.values()) {
            if(c.startsWith('hide-if-no-')) {
                const condition = c.split('hide-if-no-')[1];
                if(Object.keys(window.attsList).includes(condition)) continue;
                const tabs = el.closest('.wp-block-smarttouch-tabs');
                if(tabs) {
                    const index = [...el.parentElement.children].indexOf(el);
                    tabs.querySelector('.tab-labels').children[index].remove();
                    if(!tabs.querySelector('.tab-label.is-active')) {
                        tabs.querySelector('.tab-label').classList.add('is-active');
                        tabs.querySelector('.wp-block-smarttouch-tab').classList.remove('is-hidden');
                    }
                }
                el.remove();
            }
        }
    });
}

export function renderImage(img, colorMode = 'css', color) {
    let c = 'currentColor';
    if(!color) color = '#000000';
    return new Promise((resolve,reject)=>{
        if(img.url.split('.').pop()=='svg') {
            fetch(img.url).then(res=>res.text()).then((svg)=>{
                svg = svg.replace(/<\?xml[^\?]*\?>/,'');
                svg = svg.replace(/<!--[\s\S]*?-->\r?\n?/g,'');
                if(colorMode) {
                    if(colorMode=='select') c = color;
                    svg = svg.replace(/\#[a-f0-9A-F]{3,6}/g, c);
                    svg = svg.replace(/(<svg.*?>)(.*)<\/svg>/gs,'$1<g fill="'+c+'">$2</g></svg>');
                }
                resolve(svg);
            }).catch(()=>{
                resolve('<img src="'+img.url+'" alt="'+img.alt+'">');
            });
        } else { resolve('<img src="'+img.url+'" alt="'+img.alt+'">'); }
    });
}
